<template>
  <section>
    <section id="index">
      <Head />
    </section>
    <main>
      <section
        v-for="(item, index) in lang[local].menu"
        :id="`part-${index + 1}`"
      >
        <div :is="`part${index + 1}`" />
      </section>
    </main>
    <footer><Foot /></footer>
    <BackTop :height="100" :bottom="200">
      <div class="top"><i class="iconfont icon-shang"></i></div>
    </BackTop>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { BackTop } from "iview";
import Head from "../components/header";
import Foot from "../components/footer";
import Part1 from "../components/part/part1";
import Part2 from "../components/part/part2";
import Part3 from "../components/part/part3";
import Part4 from "../components/part/part4";
import Part5 from "../components/part/part5";
// import AOS from 'aos'
export default {
  name: "Index",
  components: {
    Head,
    BackTop,
    Part1,
    Part2,
    Part3,
    Part4,
    Part5,
    Foot,
  },
  data() {
    return {};
  },
  computed: mapState(["lang", "local", "skin"]),
  created() {},
  mounted() {
    // AOS.init()
  },
  methods: {},
  // render (h) {
  //     return (
  //     )
  // }
};
</script>

<style lang="less" scoped>
.top {
  width: 80px;
  height: 80px;
  line-height: 80px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  text-align: center;
  i {
    color: #e95b57;
    font-size: 18px;
  }
}
</style>

